import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, AlertCircle, ShieldCheck } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function MagicLink() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { setSession } = useAuth();
  const [error, setError] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setError("No magic-link token in URL.");
      return;
    }
    api.post("/auth/magic-link/consume", { token })
      .then(({ data }) => {
        setSession(data);
        nav("/admin", { replace: true });
      })
      .catch((err) => {
        setError(err.response?.data?.detail || "Magic link failed.");
      });
  }, [params, nav, setSession]);

  if (error) {
    return (
      <div className="container-narrow py-20 text-center" data-testid="magic-link-error">
        <AlertCircle className="w-10 h-10 mx-auto text-rose-500 mb-3" />
        <h1 className="font-heading text-3xl font-semibold mb-2">Magic link error</h1>
        <p className="text-ink2 max-w-lg mx-auto">{error}</p>
        <button onClick={() => nav("/login")} className="mt-6 btn-primary text-sm py-2">Sign in normally</button>
      </div>
    );
  }
  return (
    <div className="container-narrow py-20 flex flex-col items-center gap-3 text-ink2" data-testid="magic-link-loading">
      <ShieldCheck className="w-8 h-8 text-marigold" />
      <Loader2 className="w-5 h-5 animate-spin" />
      <div className="text-sm">Signing you in to mission control…</div>
    </div>
  );
}
